import React from "react";

const RejectModal = ({
  showRejectModal,
  rejectMessage,
  setShowRejectModal,
}) => {
  if (!showRejectModal) {
    return null;
  }

  return (
    <div className="fw-reject-modal-overlay">
      <div className="fw-reject-modal">

        <div className="fw-reject-modal__icon">
          ❌
        </div>

        <h2>Application Rejected</h2>

        <p>
          Your application could not be approved at this stage.
        </p>

        {rejectMessage && (
          <div className="fw-reject-modal__reason">
            <strong>Reason:</strong>

            <span>
              {rejectMessage}
            </span>
          </div>
        )}

        <button
          type="button"
          className="fw-btn fw-btn--dark fw-btn--full"
          onClick={() => {
            setShowRejectModal(false);
          }}
        >
          OK
        </button>

      </div>
    </div>
  );
};

export default RejectModal;